import React, { useEffect, useState } from "react";
import { MdOutlineDateRange, MdAccessTime, MdOutlineShowChart } from "react-icons/md";
import { axiosRequest } from "../../../_config/apiClient";
import { useNavigate } from "react-router-dom";

const DashboardHome = () => {
  const navigate = useNavigate()
  const [dashboardData, setDashboardData] = useState({
    studyTimeHours: 0,
    averageScore: 0,
  });
  const [loading, setLoading] = useState(true);
  const [attemptedTests, setAttemptedTests] = useState([]);
  const [testLoading, setTestLoading] = useState(true);


  useEffect(() => {
    const fetchDashboardSummary = async () => {
      try {
        const { data } = await axiosRequest(
          'post',
          "/user/getUserDashboardSummary",
          {},
          {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          }
        );

        setDashboardData({
          studyTimeHours: data.studyTimeHours,
          averageScore: data.averageScore,
        });
      } catch (error) {
        console.error("Dashboard API error:", error);
      } finally {
        setLoading(false);
      }
    };

    const fetchMyResults = async () => {
      try {
        const { data } = await axiosRequest(
          "post",
          "/user/getResultListing",
          {},
          {
            Authorization: `Bearer ${localStorage.getItem("user")}`,
          }
        );

        setAttemptedTests(data || []);
      } catch (error) {
        console.error("My Results API error:", error);
      } finally {
        setTestLoading(false);
      }
    };

    fetchDashboardSummary();
    fetchMyResults();
  }, []);

  const formatDuration = (text) => text || "0 mins";

  const redirectToExam = (exam) => {
    console.log("exam:: ", exam)
    sessionStorage.setItem("examConfig", JSON.stringify({
      _id: exam.targetId?._id,
      sourceType: exam?.targetType,
      testName: exam.title,
      totalQuestions: exam?.totalQuestions,
      durationMinutes: exam.durationMinutes,
      guildelines: exam.guildelines,
    }));
    navigate("/exam-instructions");
  };

  const redirectToResum = (exam) => {
    console.log("interface:: ", exam)
    sessionStorage.setItem("examConfig", JSON.stringify({
      _id: exam?.attemptId,
      sourceType: exam?.targetType,
      testName: exam.title,
      totalQuestions: exam?.totalQuestions,
      durationMinutes: exam.durationMinutes,
      totalTimeTakenSeconds: exam.totalTimeTakenSeconds,
      durationMinutes: exam.durationMinutes,
      startedAt: exam.startedAt,
      status: exam.status,
    }));
    navigate("/test-interface", {
      state:
      {
        targetId: exam?.targetId?._id,
        sessionId: exam?.attemptId,
        targetType: exam?.targetType
      }
    });
  };

  return (
    <div className="relative font-poppins">
      {/* 1. Welcome Banner */}
      <div className="relative shadow-lg flex items-center mb-8
       rounded-[10px]
       bg-gradient-to-r from-[#1D3557] to-[#3A5274]
       px-6 py-10 md:px-8
">
        <div className=" flex flex-col gap-[40px]">
          <div className='font-poppins'>
            <h1 className="text-[28px] font-[500] text-white leading-none tracking-tight mb-4">WelCome Back!</h1>
            <p className="text-[18px] font-[500] text-white leading-none tracking-tight max-w-[586px]">
              You're making great progress in your SSC CGL 2023 Guidearation. Keep it up!
            </p>
          </div>
          <div className="flex gap-10 md:gap-16 flex-wrap">
            <div className="flex items-center gap-4">
              <div className="w-[44px] h-[44px] bg-[#D9D9D93D] rounded-full flex items-center justify-center text-white text-[25px] p-[9px]">
                <MdAccessTime />
              </div>
              <div>
                <div className="text-[24px] font-[500] text-white leading-none">
                  {loading ? "—" : `${dashboardData.studyTimeHours} hrs`}
                </div>

                <div className="text-[16px] font-[500] text-white font-poppins mt-1">Study Time This Week</div>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="w-[44px] h-[44px] bg-[#D9D9D93D] rounded-full flex items-center justify-center text-white text-[25px] p-[9px]">
                <MdOutlineShowChart />
              </div>
              <div>
                <div className="text-[24px] font-[500] text-white leading-none">
                  {loading ? "—" : `${dashboardData.averageScore}%`}
                </div>

                <div className="text-[16px] font-[500] text-white font-poppins mt-1">Average Test Score</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 2. Attempted Tests Section */}
      <div className="mt-8 pb-8">
        <h2 className="text-[20px] md:text-[22px] font-[500] text-[#333333] mb-6 tracking-tight">
          Attempted Tests
        </h2>
        {/* <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {[
            { title: "SSC CGL Tier-I Full Test 15", date: "Today, 7:00 PM", time: "60", desc: "100 questions covering all four sections. Based on latest exam pattern." },
            { title: "Quantitative Aptitude Speed Test", date: "Tomorrow, 10:00 AM", time: "30 mins", desc: "35 questions to test your calculation speed and accuracy." },
            { title: "Current Affairs Weekly Test", date: "Apr 15, 9:00 AM", time: "20 mins", desc: "50 questions from last week's current affairs (Apr 8-14)." }
          ].map((test, idx) => (
            <div
              key={idx}
              className="bg-white rounded-[10px] p-5 shadow-[0_1px_4px_rgba(0,0,0,0.25)] border-l-[3px] border-[#E63946] flex flex-col h-full min-h-[260px]"
            >
              <h3 className="font-bold text-[16px] text-[#333333] mb-4 leading-tight tracking-tight">{test.title}</h3>
              <div className="flex justify-between items-center text-[#333333] text-[14px] font-bold mt-4 mb-4 gap-[6px]">
                <span className="flex font-[700] items-center gap-2 text-[14px]"><MdOutlineDateRange className="text-[16px] font-[700] " /> {test.date}</span>
                <span className="flex font-[700] items-center gap-2 text-[14px]"><MdAccessTime className="text-[16px] font-[700]" /> {test.time}</span>
              </div>
              <p className="text-[16px] font-[600] text-[#333333] leading-[1.5] tracking-tight mt-2 mb-6 flex-1">
                {test.desc}
              </p>
              <div className="flex gap-2">
                {['Resume', 'Solutions', 'Retake'].map((label) => (
                  <button
                    key={label}
                    className="flex-1 py-[6px] px-[20px] bg-[#E63946] text-white text-[14px] font-medium font-poppins rounded-[6px] transition-all hover:bg-red-700 mb-6 active:scale-95"
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div> */}


        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
          {testLoading ? (
            <div className="text-center text-gray-500 col-span-full">
              Loading tests...
            </div>
          ) : attemptedTests.length === 0 ? (
            <div className="text-center text-gray-500 col-span-full">
              No attempted tests found
            </div>
          ) : (
            attemptedTests.map((test) => (
              <div
                key={test.attemptId}
                className="bg-white rounded-[10px] p-5
        shadow-[0_1px_4px_rgba(0,0,0,0.25)]
        border-l-[3px] border-[#E63946]
        flex flex-col h-full min-h-[260px]"
              >
                {/* TITLE */}
                <h3 className="font-bold text-[16px] text-[#333333] mb-4 leading-tight tracking-tight">
                  {test.title}
                </h3>

                {/* DATE + TIME */}
                <div className="flex justify-between items-center text-[#333333] text-[14px] font-bold mt-4 mb-4 gap-[6px]">
                  <span className="flex items-center gap-2">
                    <MdOutlineDateRange className="text-[16px]" />
                    {test.dateTimeText}
                  </span>
                  <span className="flex items-center gap-2">
                    <MdAccessTime className="text-[16px]" />
                    {formatDuration(test.durationText)}
                  </span>
                </div>

                {/* DESCRIPTION */}
                <p className="text-[16px] font-[600] text-[#333333] leading-[1.5] tracking-tight mt-2 mb-6 flex-1">
                  {test.totalQuestions} questions in this test.
                </p>

                {/* ACTION BUTTONS */}
                <div className="flex gap-2">

                  {/* PAUSED */}
                  {test.status === "paused" && (
                    <button
                      onClick={() => redirectToResum(test)}
                      className="flex-1 py-[6px] px-[20px] bg-[#E63946] text-white text-[14px] font-medium rounded-[6px] hover:bg-red-700 mb-6"
                    >
                      Resume
                    </button>
                  )}

                  {/* SUBMITTED */}
                  {test.status === "submitted" && (
                    <button
                      disabled
                      className="flex-1 py-[6px] px-[20px] bg-[#E63946] text-white text-[14px] font-medium rounded-[6px] mb-6 cursor-not-allowed"
                    >
                      Complete
                    </button>
                  )}

                  {/* Solutions (sirf jab paused na ho) */}
                  {test.status !== "paused" && test.actions.canViewSolutions && (
                    <button
                      onClick={() =>
                        navigate('/test-result', {
                          state: { attemptId: test?.attemptId }
                        })
                      }
                      className="flex-1 py-[6px] px-[20px] bg-[#E63946] text-white text-[14px] font-medium rounded-[6px] hover:bg-red-700 mb-6"
                    >
                      Solutions
                    </button>
                  )}

                  {/* Retake */}
                  {test.actions.canRetake && (
                    <button
                      onClick={() => redirectToExam(test)}
                      className="flex-1 py-[6px] px-[20px] bg-[#E63946] text-white text-[14px] font-medium rounded-[6px] hover:bg-red-700 mb-6"
                    >
                      Retake
                    </button>
                  )}

                </div>
              </div>
            ))
          )}
        </div>


      </div>
    </div >
  );
};

export default DashboardHome;